module.exports = __webpack_public_path__ + "static/media/data-processing-consent.ec78a7aa.pdf";